/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- TRENDING - CONFIGURATION PAGE : STYLES --------------- ++++++++++ */
export default {
    trendingconfig: {
    }
};
